module.exports = __webpack_public_path__ + "static/logo-ecf85376b3da3f07329e5937ea0bb298.png";